import { createAsyncThunk, createSelector, createSlice, PayloadAction } from '@reduxjs/toolkit'
import { setLoader } from './loader.slice'
import mainApiService from '../../Services'
import { CONTAINER_MANAGEMENT_CRUD } from '../../Constants/ApiDefinations/index'
import { IManageContainerSlice } from '../../Models/ManageContainer'

const initialState: IManageContainerSlice = {
  containerDefinitionDetails: {},
  containerDetails: {},
  parentContainerDetail: {},
  itemDetail: {},
}

const manageContainerSlice = createSlice({
  name: 'manageContainer',
  initialState,
  reducers: {
    setContainerDefinitionDetails: (state, action: PayloadAction<any>) => {
      state.containerDefinitionDetails = { ...action.payload }
    },
    setContainerDetails: (state, action: PayloadAction<any>) => {
      state.containerDetails = { ...action.payload }
    },
    setParentContainerDetail: (state, action: PayloadAction<any>) => {
      state.parentContainerDetail = { ...action.payload }
    },
    setContainerItemDetail: (state, action: PayloadAction<{ [key: string]: any[] }>) => {
      state.itemDetail = { ...action.payload }
    },
    resetContainerData: () => initialState,
  },
})
export const {
  setContainerDefinitionDetails,
  setContainerDetails,
  setParentContainerDetail,
  resetContainerData,
  setContainerItemDetail,
} = manageContainerSlice.actions
export default manageContainerSlice

export const manageContainerSelector = (state: any) => state.manageContainer

export const containerDetailSelector = createSelector(
  [manageContainerSelector],
  (parameters) => parameters.containerDetails,
)
export const containerDefinitionDetailSelector = createSelector(
  [manageContainerSelector],
  (parameters) => parameters.containerDefinitionDetails,
)
export const parentContainerDetailSelector = createSelector(
  [manageContainerSelector],
  (parameters) => parameters.parentContainerDetail,
)
export const itemDetailSelector = createSelector(
  [manageContainerSelector],
  (parameters) => parameters.itemDetail,
)

export const getContainerDefinitionDetailById = createAsyncThunk(
  'manageContainer/getContainerDefinitionDetailById',
  async (data: string, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: ContainerCRUDAPIDefinitionModal =
      CONTAINER_MANAGEMENT_CRUD.GET_CONTAINER_DEFINITION_DETAIL_BY_ID(data)
    const result: any = await mainApiService(requestedData)
    dispatch(setContainerDefinitionDetails(result?.data))
    dispatch(setLoader(false))
    return result
  },
)
export const getContainerDetailById = createAsyncThunk(
  'manageContainer/getContainerDetailById',
  async (data: string, { dispatch }) => {
    dispatch(setLoader(true))
    const requestedData: ContainerCRUDAPIDefinitionModal =
      CONTAINER_MANAGEMENT_CRUD.GET_CONTAINER_DETAIL_BY_ID(data)
    const result: any = await mainApiService(requestedData)
    dispatch(setContainerDetails(result?.data))
    dispatch(setLoader(false))
    return result
  },
)
export const getContainerListAPICall = createAsyncThunk(
  'manageContainer/containerList',
  async (payload: any, { dispatch }) => {
    const requestedData: any = CONTAINER_MANAGEMENT_CRUD.LISTING(payload)
    const data: any = await mainApiService(requestedData)
    return data
  },
)

export interface ContainerCRUDAPIDefinitionModal {
  url: string
  method: string
  data: any
}
